<div class="container">
  <dxo-card data-e2e="filter-eoi-card">
    <div class="header-container">
      <h2 class="card-body-header" data-e2e="FormsCardHeader">Filter EOI applicants</h2>
      <div (click)="clearFilters()" (keydown)="clearFilters()" class="link" data-e2e="clear-filters-link">Clear filters</div>
    </div>
    <card-body>
      <form [formGroup]="eoiApplicantForm" (ngSubmit)="submit()">
        <div class="data-container">
          <div class="text-input">
            <div class="row-input">
              <dxo-text-input
                [label]="applicantData.employeeNameOrId.label ?? ''"
                [maxlength]="80"
                formControlName="employeeNameOrId"
                [dxoDataset]="[{ selector: 'input', data: { e2e: 'employee-name-input' } }]"
              ></dxo-text-input>
              <dxo-text-input
                [label]="applicantData.applicantName.label ?? ''"
                [maxlength]="80"
                formControlName="applicantName"
                (valueChange)="applicantName$.next($event)"
                [dxoDataset]="[{ selector: 'input', data: { e2e: 'applicant-name-input' } }]"
              ></dxo-text-input>
            </div>
            <div class="row-input">
              <dxo-text-input
                [label]="submittedFromDateLabel"
                [maxlength]="80"
                type="date"
                formControlName="submittedFromDate"
                [error]="!validateDateFormat(eoiApplicantForm.controls.submittedFromDate.value)"
                [errorMessage]="dateFormatMessage"
                [dxoDataset]="[{ selector: 'input', data: { e2e: 'submitted-from-date-input' } }]"
              ></dxo-text-input>
              <div class="placeholder-label">
                <dxo-text-input
                  [maxlength]="80"
                  type="date"
                  [label]="submittedToDateLabel"
                  formControlName="submittedToDate"
                  [dxoDataset]="[{ selector: 'input', data: { e2e: 'submitted-to-date-input' } }]"
                  [error]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.submittedFromDate.value,
                      eoiApplicantForm.controls.submittedToDate.value
                    ) || !validateDateFormat(eoiApplicantForm.controls.submittedToDate.value)
                  "
                  [errorMessage]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.submittedFromDate.value,
                      eoiApplicantForm.controls.submittedToDate.value
                    )
                      ? dateErrorMessage
                      : !validateDateFormat(eoiApplicantForm.controls.submittedToDate.value)
                        ? dateFormatMessage
                        : ''
                  "
                ></dxo-text-input>
              </div>
            </div>
            <div class="row-input">
              <dxo-text-input
                [label]="decisionFromDateLabel"
                [maxlength]="80"
                type="date"
                formControlName="decisionFromDate"
                [error]="!validateDateFormat(eoiApplicantForm.controls.decisionFromDate.value)"
                [errorMessage]="dateFormatMessage"
                data-e2e="decision-from-date-input"
              ></dxo-text-input>
              <div class="placeholder-label">
                <dxo-text-input
                  [maxlength]="80"
                  type="date"
                  [label]="decisionToDateLabel"
                  formControlName="decisionToDate"
                  data-e2e="decision-to-date-input"
                  [error]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.decisionFromDate.value,
                      eoiApplicantForm.controls.decisionToDate.value
                    ) || !validateDateFormat(eoiApplicantForm.controls.decisionToDate.value)
                  "
                  [errorMessage]="
                    isDateGreaterThan(
                      eoiApplicantForm.controls.decisionFromDate.value,
                      eoiApplicantForm.controls.decisionToDate.value
                    )
                      ? dateErrorMessage
                      : !validateDateFormat(eoiApplicantForm.controls.decisionToDate.value)
                        ? dateFormatMessage
                        : ''
                  "
                ></dxo-text-input>
              </div>
            </div>
          </div>
          <div id="eoi-container" data-e2e="eoi-status-filter">
            <dxo-label-value [label]="'EOI status'"></dxo-label-value>
            <div id="status-container">
              <div class="status" *ngFor="let status of statusList">
                <div
                  class="status-value"
                  [class.selected]="isSelected(status)"
                  (click)="toggleStatusSelection(status)"
                  (keydown)="toggleStatusSelection(status)"
                  [attr.data-e2e]="getStatusE2E(status)"
                >
                  {{ status }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </card-body>
  </dxo-card>

  <div class="eoi-table-container">
    <dxo-card data-e2e="eoi-applicants-card">
      <div class="header-container">
        <h2 class="card-body-header" data-e2e="FormsCardHeader">EOI applicants</h2>
        <div (click)="exportTableToXLSX()" (keydown)="exportTableToXLSX()" class="link">Download XLSX</div>
      </div>
      <div class="loader-container">
        <dxo-circular-loader *ngIf="isLoading" [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
      </div>
      <card-body id="eoi-card" *ngIf="applicants$ | async as applicants" data-e2e="applicants-card">
        <dxo-data-table
          [headers]="tableHeaders"
          [items]="applicants.listEoi"
          [showCardViewWhenMobile]="true"
          [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
        >
          <ng-template dxoHeaderKey="employee" data-e2e="employee-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('EmployeeName')"
              (keypress)="onClickTableHeader('EmployeeName')"
            >
              Employee name
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'EmployeeName'
                "
                [color]="searchParameter.sortField === 'EmployeeName' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="status" data-e2e="status-column">
            <span
              tabindex="0"
              class="sort-header"
              (click)="onClickTableHeader('Status')"
              (keypress)="onClickTableHeader('Status')"
            >
              Status
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'Status'
                "
                [color]="searchParameter.sortField === 'Status' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>

          <ng-template dxoKey="status" let-item>
            <span class="row-cell">
              <span class="status-indicator" [style.background-color]="item.indicator"></span>
              {{ item.status }}
            </span>
          </ng-template>

          <ng-template dxoHeaderKey="applicant" data-e2e="applicant-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('ApplicantName')"
              (keypress)="onClickTableHeader('ApplicantName')"
            >
              Applicant
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'ApplicantName'
                "
                [color]="searchParameter.sortField === 'ApplicantName' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="coverage" data-e2e="coverage-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('Coverage')"
              (keypress)="onClickTableHeader('Coverage')"
            >
              Coverage
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending && searchParameter.sortField === 'Coverage'
                "
                [color]="searchParameter.sortField === 'Coverage' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="amount" data-e2e="amount-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('Amount')"
              (keypress)="onClickTableHeader('Amount')"
            >
              Amount
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending && searchParameter.sortField === 'Amount'
                "
                [color]="searchParameter.sortField === 'Amount' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="submitted" data-e2e="submitted-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('SubmittedFromDate')"
              (keypress)="onClickTableHeader('SubmittedFromDate')"
            >
              Submitted
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'SubmittedFromDate'
                "
                [color]="searchParameter.sortField === 'SubmittedFromDate' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
          <ng-template dxoHeaderKey="decision" data-e2e="decision-column">
            <span
              class="sort-header"
              tabindex="0"
              (click)="onClickTableHeader('DecisionToDate')"
              (keypress)="onClickTableHeader('DecisionToDate')"
            >
              Decision
              <dxo-icon
                [class.ascending]="
                  searchParameter.sortDirection === SortDirection.Ascending &&
                  searchParameter.sortField === 'DecisionToDate'
                "
                [color]="searchParameter.sortField === 'DecisionToDate' | getSortIconColor"
                [fontSize]="20"
                [right]="true"
                >sort</dxo-icon
              >
            </span>
          </ng-template>
        </dxo-data-table>
        <div class="paginator">
          <dxo-server-pagination
            [itemCount]="applicants.totalResults"
            [currentPage]="searchParameter.page"
            [pageSize]="searchParameter.pageSize"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"
          ></dxo-server-pagination>
        </div>
      </card-body>
    </dxo-card>
  </div>
</div>
